<template>
  <div class="buttons">
    <b-tooltip v-if="qaShare" :label="$gettext('AboutMe.action.share')" position="is-top">
      <b-dropdown position="is-bottom-left">
        <button class="button" style="border: 0px; background-color: transparent;" slot="trigger">
          <b-icon
            pack="fa"
            icon="link"
          ></b-icon>
        </button>
        <b-dropdown-item @click="share({ compact: false })">
          <translate>AboutMe.action.share.default</translate>
        </b-dropdown-item>
        <b-dropdown-item v-if="qaShareCompactView" @click="share({ compact: true })">
          <translate>AboutMe.action.share.compact</translate>
        </b-dropdown-item>
      </b-dropdown>
    </b-tooltip>
    <b-tooltip v-if="qaPrint" :label="$gettext('AboutMe.action.print')" position="is-top">
      <button
        class="button"
        style="border: 0px; background-color: transparent;"
        @click="print"
      >
        <b-icon
          pack="fa"
          icon="print"
        ></b-icon>
      </button>
    </b-tooltip>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { CopyToClipboard, ToastSuccess, ToastError } from '@/utils'

export default {
  name: 'fob-aboutme-list-quick-actions',
  props: {
    'qa-share': Boolean,
    'qa-share-compact-view': Boolean,
    'qa-print': Boolean
  },
  computed: {
    ...mapGetters({
      userFisPersid: 'user/fisPersid',
      activeResourceType: 'aboutme/getResourceType'
    })
  },
  methods: {
    print () {
      window.print()
    },
    share ({ compact }) {
      const to = {
        name: 'public',
        params: {
          type: 'person',
          id: this.userFisPersid,
          resourceType: this.activeResourceType || 'forschungsprojekt'
        }
      }

      if (compact) {
        to.query = {
          compact: true
        }
      }
      // retrieve route information for public
      const route = this.$router.resolve(to, this.$route)
      const url = `${window.location.origin}${route.href}`

      CopyToClipboard(url).then(() => {
        ToastSuccess(this.$gettext('AboutMe.toast.clipboard.success'))
      }, () => {
        ToastError(this.$gettext('AboutMe.toast.clipboard.error'))
      })
    }
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/aboutme/AboutMeListQuickActions.vue